import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentProd = {
  locale: 'en-AU',
  production: true,
  api: '/api',
  domain: 'workbuddy.app',
  auth: {
    local: {
      callbackUrl: 'http://{0}:4000/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.app',
    logoutHref: 'https://id.workbuddy.app/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: '',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.Production
} as EnvironmentConfiguration;
